import Button from "@mui/material/Button";
import classes from "./RoundButton.module.css";

const RoundButton = (props) => {
  const colorClass = props.isSelected ? 
  `${classes.button} ${classes.yellow}` : 
  `${classes.button} ${classes.transparent}`

  return (
    <div className={classes.roundButton}>
      <Button
        type={props.type}
        className={colorClass}
        onClick={props.onClick}
        sx={props.buttonStyle}
      >
        {props.children}
      </Button>
    </div>
  );
};

export default RoundButton;